/**
 * Validation Result Types for Planning Grid Operations
 *
 * Used by DraftStateService to provide structured validation feedback
 * for all edit operations (add, remove, move assignments).
 */

export type ValidationErrorCode =
  | 'duplicate' // Same employee already assigned to this shift on this date
  | 'overlap' // Employee has overlapping shifts on this date
  | 'capacity_exceeded' // Shift is at maximum capacity (soft warning, may allow)
  | 'metadata_not_loaded' // Shifts not loaded yet, cannot validate
  | 'skill_mismatch'; // Employee doesn't have required skills for the shift

export interface ValidationResult {
  success: boolean;
  error?: ValidationErrorCode;
  message?: string; // Human-readable message for UI display
}

// Usage examples:
// { success: true }
// { success: false, error: 'duplicate', message: 'Anna B. is already assigned to Morning shift on Jan 20' }
// { success: false, error: 'metadata_not_loaded', message: 'Shifts not loaded yet' }
